import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Config } from 'src/app/models/configuration.model';
import { AudioService } from 'src/app/services/audio.service';
import { ContentService } from 'src/app/services/content.service';
import { MultimodalService } from 'src/app/services/multimodal.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent implements OnInit {

  contact_info: any = null;
  current_year = new Date().getFullYear();
  public config: Config;

  constructor(private route: ActivatedRoute, private contentService: ContentService, private multimodalService: MultimodalService) {
    this.config = this.multimodalService.config;
  }

  loadPage(url: string) {
    if (this.multimodalService.config.modalities.filter(m => m.name === 'audio')[0].active) {
      this.multimodalService.playAudioClick();
    }
    if (url) {
      setTimeout(() => window.open(url, '_blank'), 500);
    }
  }

  ngOnInit() {
    this.contentService.getContactInfo().subscribe(res => {
      this.contact_info = res;
    });
  }


  linkTo(url: string) {
    this.multimodalService.playAudioClick();
    this.multimodalService.playHapticButtonClick(150);
    window.open(url);
  }
}
